import Marquee from "react-fast-marquee";

const items = [
  "NO CLOSING COSTS",
  "FAST CASH OFFER",
  "BUY AS-IS",
  "NO REPAIRS NEEDED",
  "CLOSE ON YOUR TIMELINE",
  "ZERO COMMISSIONS",
];

export const TrustMarquee = () => (
  <div data-testid="trust-marquee" className="bg-emerald-900 py-5 overflow-hidden">
    <Marquee gradient={false} speed={40}>
      {items.concat(items).map((t, i) => (
        <span
          key={i}
          className="mx-8 text-stone-100 font-semibold tracking-[0.2em] text-sm flex items-center"
        >
          {t}
          <span className="ml-8 text-amber-400">•</span>
        </span>
      ))}
    </Marquee>
  </div>
);
